"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ComboButtonStyled = require("./ComboButton-styled");

var _Popover = _interopRequireDefault(require("../Popover"));

var _CaretDownIcon = _interopRequireDefault(require("calcite-ui-icons-react/CaretDownIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ComboButton =
/*#__PURE__*/
function (_Component) {
  _inherits(ComboButton, _Component);

  function ComboButton() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ComboButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ComboButton)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      open: false
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "togglePopover", function () {
      _this.setState({
        open: !_this.state.open
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "closePopover", function () {
      _this.setState({
        open: false
      });
    });

    return _this;
  }

  _createClass(ComboButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          onClick = _this$props.onClick,
          label = _this$props.label,
          icon = _this$props.icon,
          iconPosition = _this$props.iconPosition,
          dropdownIcon = _this$props.dropdownIcon,
          half = _this$props.half,
          closeOnSelect = _this$props.closeOnSelect,
          other = _objectWithoutProperties(_this$props, ["children", "onClick", "label", "icon", "iconPosition", "dropdownIcon", "half", "closeOnSelect"]);

      var wrappedIcon;

      if (icon) {
        wrappedIcon = _react.default.cloneElement(icon, _objectSpread({}, icon.props, {
          style: _objectSpread({
            fill: 'currentColor',
            verticalAlign: 'bottom',
            marginLeft: iconPosition === 'after' ? '0.75em' : '-0.25em',
            marginRight: iconPosition === 'before' ? '0.75em' : '-0.25em'
          }, icon.props.style)
        }));
      }

      var comboButton = _react.default.createElement(_ComboButtonStyled.StyledComboButtonContainer, {
        half: half
      }, _react.default.createElement(_ComboButtonStyled.StyledComboButton, _extends({
        onClick: onClick
      }, other), iconPosition === 'before' ? wrappedIcon : null, label, iconPosition === 'after' ? wrappedIcon : null), _react.default.createElement(_Popover.default, {
        open: this.state.open,
        onRequestClose: this.closePopover,
        closeOnSelect: closeOnSelect,
        placement: "bottom-end",
        targetContainerStyles: {
          display: 'block'
        },
        targetEl: _react.default.createElement(_ComboButtonStyled.StyledComboButtonDropdown, _extends({
          onClick: this.togglePopover
        }, other), dropdownIcon)
      }, children));

      return comboButton;
    }
  }]);

  return ComboButton;
}(_react.Component);

ComboButton.propTypes = {
  /** The content of the component; should be a Menu with MenuItems for the dropdown. */
  children: _propTypes.default.node,

  /** The HTML type property of the primary ComboButton. */
  type: _propTypes.default.oneOf(['button', 'reset', 'submit']),

  /** Style prop used to render a clear ComboButton. */
  clear: _propTypes.default.bool,

  /** Style prop used to render a clear-gray ComboButton. */
  clearGray: _propTypes.default.bool,

  /** Style prop used to render an extra small ComboButton. */
  extraSmall: _propTypes.default.bool,

  /** Style prop used to render a small ComboButton. */
  small: _propTypes.default.bool,

  /** Style prop used to render a large ComboButton. */
  large: _propTypes.default.bool,

  /** Style prop used to render an extra large ComboButton. */
  extraLarge: _propTypes.default.bool,

  /** Style prop used to render a 100% width ComboButton. */
  fullWidth: _propTypes.default.bool,

  /** Style prop used to render a 50% width ComboButton. */
  half: _propTypes.default.bool,

  /** Style prop used to render a red ComboButton. */
  red: _propTypes.default.bool,

  /** Style prop used to render a green ComboButton. */
  green: _propTypes.default.bool,

  /** The HTML disabled property of the primary ComboButton. */
  disabled: _propTypes.default.bool,

  /** The HTML href property of the primary ComboButton; results in rendering an anchor element. */
  href: _propTypes.default.string,

  /** The icon that will be displayed as the content of a ComboButton. */
  icon: _propTypes.default.node,

  /** The position of the icon in relation to other children in a ComboButton. */
  iconPosition: _propTypes.default.oneOf(['after', 'before']),

  /** The icon used inside the dropdown button */
  dropdownIcon: _propTypes.default.node,

  /** Whether or not the Popover should trigger onRequestClose when an element is selected. */
  closeOnSelect: _propTypes.default.bool
};
ComboButton.defaultProps = {
  type: 'button',
  iconPosition: 'after',
  closeOnSelect: true,
  dropdownIcon: _react.default.createElement(_CaretDownIcon.default, {
    filled: true,
    size: 14
  }),
  onClick: function onClick() {}
};
ComboButton.displayName = 'ComboButton';
var _default = ComboButton;
exports.default = _default;